import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { ExternalEventsResponse } from "@/TS/Interfaces/global_interfaces";
export const usePublicExternalEvents = clubSlug => {
  const $ = _c(2);
  let t0;
  if ($[0] !== clubSlug) {
    t0 = {
      queryKey: ["public-external-events", clubSlug],
      queryFn: async () => {
        const response = await fetch(`/api/external-events/public?clubSlug=${clubSlug}`);
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || "Erreur lors de la r\xE9cup\xE9ration des \xE9v\xE9nements");
        }
        return await response.json();
      },
      refetchOnWindowFocus: true,
      staleTime: 30000
    };
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};